import { Button, Stack, Typography } from '@mui/material';

interface Props {
  offset: number;
  limiet: number;
  aantal: number;
  onOffset: (offset: number) => void;
}

/**
 * Knoppen om door een lijst te bladeren. De API geeft geen totaal, dus er is een volgende pagina zolang de
 * huidige pagina vol is.
 * @param props De huidige positie, de paginagrootte, het aantal op deze pagina en wat er bij bladeren gebeurt.
 * @returns De knoppen, of niets als er maar één pagina is.
 */
export function Lijstpaginering({ offset, limiet, aantal, onOffset }: Props) {
  const heeftVolgende = aantal >= limiet;
  const heeftVorige = offset > 0;
  if (!heeftVolgende && !heeftVorige) {
    return null;
  }
  return (
    <Stack direction="row" spacing={1} sx={{ justifyContent: 'flex-end', alignItems: 'center', mt: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
        {aantal === 0 ? 'Geen resultaten' : `${offset + 1} – ${offset + aantal}`}
      </Typography>
      <Button size="small" disabled={!heeftVorige} onClick={() => onOffset(Math.max(0, offset - limiet))}>
        Vorige
      </Button>
      <Button size="small" disabled={!heeftVolgende} onClick={() => onOffset(offset + limiet)}>
        Volgende
      </Button>
    </Stack>
  );
}
